import React, { useEffect, useRef, useState } from 'react'
import './ExpenseManager.css'
import {FiSearch} from 'react-icons/fi'

const ExpenseManager = () => {
    const [click, setClick] = useState(false);
    const [showForm, setShowForm] = useState(false);

    const [expense, updateExpense] = useState(0);
    const [income, updateIncome] = useState(0)

    
    const initialItemList = [
        {description: 'salary', amount:5000, type:'income' },
        {description: 'lunch', amount:700, type:'expense' },
        {description: 'dinner', amount:2300, type:'expense' },
        {description: 'crypto', amount:3000, type:'income' },
        {description: 'shoes', amount:300, type:'expense' }
    ];

    const [itemList, setItemList] = useState(initialItemList);
    const [newItem, setNewItem] = useState({description:'', amount:'', type:'income'});

    const [searchText, updateSearchText] = useState('');
    const [filterdList, updateFilteredList] = useState(itemList);
    const filterData = (searchText) => {
        if(!searchText || !searchText.trim().length){
            updateFilteredList(itemList);
            return;
        }
        let list = [...itemList];
        list = list.filter((item)=>item.description.toLowerCase().includes(searchText.toLowerCase().trim()));
        updateFilteredList(list);
    }

    useEffect(()=>filterData(searchText), [itemList]);

    const openExpenseForm = () => {
        console.log(JSON.stringify(newItem));
        setClick(!click);
        setShowForm(!showForm);
        resetForm()
    }

    const resetForm = () => {
        let resetItem = {description:'', amount:'', type:'income'};
        setNewItem(resetItem)
    }

    const updateList = () => {
        const newArr = [...itemList];
        console.log("..."+enabled)
        newArr.push(newItem);
        setItemList(newArr);
        resetForm()
        openExpenseForm()
    }

    const enabled = (newItem.amount.length > 0 || newItem.amount>0) && newItem.description.length > 0;

    const calculateBalance = () => {
        let exp = 0;
        let inc = 0;

        itemList.map((item) => {
            console.log(JSON.stringify(item));
            item.type === 'expense' ? (exp = exp + item.amount) : (inc = inc + item.amount);
        })

        updateExpense(exp);
        updateIncome(inc);
    }

    useEffect(() => {calculateBalance()}, [itemList]);

    const buttonRef = useRef(null);

    useEffect(() => {
        const handleMouseMove = (event) => {
        const button = buttonRef.current;

        if(button){
            const rect = button.getBoundingClientRect();
            const x = event.clientX;
            const y = event.clientY;

            if (
                x >= rect.left - 40 &&
                x <= rect.right + 40 &&
                y >= rect.top - 40 &&
                y <= rect.bottom + 40
            ) {
                button.style.transform = 'translate(0px, 0px, 50px, 50px)';
            } else {
                button.style.transform = 'translate(0, 0)';
            }
        }
        
        };

        if (buttonRef.current)
        document.addEventListener('mousemove', handleMouseMove);

        return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);


  return (
    <div className='border-container'>
        <div className='main-container'>
            <div className='heading'>
                <h3>Expense Manager</h3>
            </div>
            
            <div className='main-balance'>
                <div className='rem-balance'><span></span><h4>Balance: &#8377;{income - expense}</h4></div>
                {click ? <button ref={buttonRef} className='bttn' onClick={()=>openExpenseForm()}>CANCEL</button> 
                    : <button ref={buttonRef} className='bttn' onClick={()=>openExpenseForm()}>ADD</button>
                }                
            </div>
            <div className='add-expense' style={showForm ? {display:"initial"} : {display:"none"}}>
                <input className='ip' required value={newItem.amount} type='number' onChange={(e)=>setNewItem({...newItem, amount: parseInt(e.target.value)})} placeholder="amount"/>
                <input className='ip' required value={newItem.description} type='text' onChange={(e)=>setNewItem({...newItem, description: e.target.value})} placeholder="description"/>
                <div className='txn-type' >
                    <label>
                        <input type="radio" name="dark" onChange={()=>setNewItem({...newItem, type: 'expense'})} checked = {newItem.type ==='expense'} />
                        <span class="design" onClick={()=>setNewItem({...newItem, type: 'expense'})}></span>
                        <span class="val" onClick={()=>setNewItem({...newItem, type: 'expense'})}>Expense</span>
                    </label>

                    <label>
                        <input type="radio" name="dark" onChange={()=>setNewItem({...newItem, type: 'income'})} checked = {newItem.type ==='income'}/>
                        <span class="design" onClick={()=>setNewItem({...newItem, type: 'income'})}></span>
                        <span class="val" onClick={()=>setNewItem({...newItem, type: 'income'})}>Income</span>
                    </label>
                </div>
                <button className={!enabled ? 'bttn add-txn disable' : 'bttn add-txn'} disabled={!enabled} onClick={()=>updateList()} >Add Transaction</button>
            </div>
            <div className='balance'>
                <div className='expense-balance'>
                    <h2>Expense</h2>
                    <p>&#8377;{expense}</p>
                </div>
                <div className='income-balance'>
                    <h2>Income</h2>
                    <p>&#8377;{income}</p>
                </div>
            </div>
            <h5>Transactions:</h5>
            <div className='search-bar'>
                <input type="text" placeholder="Search..." name="search" value={searchText} onChange={(e)=>{ updateSearchText(e.target.value); filterData(e.target.value)}}/>
                <button type="submit"><FiSearch /></button>
            </div>
            <div className='txn-list'>
                {filterdList.map((item, index)=>(
                    <div key={index} className= {(item.type === 'expense') ? 'txn-item' : 'txn-item expense' }>
                        <p>{item.description}</p>
                        <p>&#8377;{item.amount}</p>
                    </div>
                ))}
            </div>
        </div>
    </div>
  )
}

export default ExpenseManager